import { forwardRef, Ref } from 'react';

import { TamaguiElement } from '@tamagui/core';

import { Box, BoxProps } from './Box';

export type RowProps = BoxProps;

/**
 * Row is a convenience component that renders a Box with flexDirection set to 'row'.
 * It accepts all the same props as Box.
 */
export const Row = forwardRef(function Row(props: RowProps, ref: Ref<TamaguiElement>) {
  return <Box ref={ref} flexDirection="row" {...props} />;
});
